/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";

import SuccessMessagePopupCard from "./SuccessMessagePopupCard";
import SubscribeToNewsLetterForm from "./SubscribeToNewsLetterForm";
// import { DGAButton } from "components/Shared/dga-button/DGAButton";
import IsRtl from "components/Shared/isRtl";
import { DGAButton } from "components/Shared/dga-button/DGAButton";

interface SubscribeToNewsLetterProps {
  buttonText?: string;
  locale?: string;
  NewsLetterFormData: any;
  isBottomLink?: boolean;
}

const SubscribeToNewsLetter: React.FC<SubscribeToNewsLetterProps> = ({
  buttonText,
  locale,
  NewsLetterFormData,
  isBottomLink,
}) => {
  const [isPopupOpen, setPopupOpen] = React.useState(false);

  const [subscribeFormResponse, setSubscribeFormResponse] = React.useState({
    success: false,
    message: "",
  });

  const [isSubscribeFormLoading, setIsSubscribeFormLoading] = React.useState(false);

  useEffect(() => {
    if (!isPopupOpen) {
      setSubscribeFormResponse({
        success: false,
        message: "",
      });
      setIsSubscribeFormLoading(false);
    }
  }, [isPopupOpen]);

  if (!buttonText) return <></>;

  return (
    <>
      {/* subscribe to news letter button */}
      {/* <button
        onClick={() => setPopupOpen(true)}
        className="rounded border border-neutral-300 disabled:opacity-60 disabled:!bg-[#e5e7eb] disabled:cursor-not-allowed bg-neutral-100 hover:bg-neutral-300 transition-colors px-3 py-[6px] font-medium text-sm text-primary-1000"
      >
        {buttonText}
      </button> */}
   {isBottomLink==false &&   <DGAButton
        variant="secondaryOutline"
        size="md"
        buttonContent={buttonText}
        onClick={() => setPopupOpen(true)}
      />}
{isBottomLink ==true && (
            <button
              type="button"
              onClick={() => setPopupOpen(true)}
              className="text-primary-1000 cursor-pointer hover:text-primary-1000/80 hover:underline underline text-[14px] bg-transparent border-0 p-0 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2 rounded"
            >
              {buttonText}
            </button>
          )}

      {/* subscribe to news letter popup, when button is clicked */}
      {isPopupOpen && (
        <div
          dir={IsRtl() ? "rtl" : "ltr"}
          className="fixed top-0  left-0 right-0 bottom-0 w-screen h-screen flex items-center justify-center text-white bg-gray-600 bg-opacity-70 z-[10000] p-4"
        >
          {/* transparent background div for clicking outside to close the popup */}
          <div
            onClick={(e) => {
              e.stopPropagation();
              setPopupOpen(false);
            }}
            className="absolute w-full h-full top-0 left-0 right-0 bottom-0 bg-transparent z-10 transition-colors animate-appearance-in"
          />

          {subscribeFormResponse?.success ? (
            <SuccessMessagePopupCard
              Title={NewsLetterFormData?.fields?.Title?.value}
              Subtitle={NewsLetterFormData?.fields?.Subtitle?.value}
              Description={NewsLetterFormData?.fields?.Description?.value}
              setPopupOpen={setPopupOpen}
            />
          ) : (
            <SubscribeToNewsLetterForm
              locale={locale as string}
              isSubscribeFormLoading={isSubscribeFormLoading}
              NewsLetterFormData={NewsLetterFormData}
              subscribeFormResponseMessage={subscribeFormResponse?.message}
              setSubscribeFormResponse={setSubscribeFormResponse}
              setPopupOpen={setPopupOpen}
              setIsSubscribeFormLoading={setIsSubscribeFormLoading}
            />
          )}
        </div>
      )}
    </>
  );
};

export default React.memo(SubscribeToNewsLetter);
